import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	OnInit,
	Output,
	Input,
	inject,
	signal,
	WritableSignal,
} from '@angular/core';

import { MatSelectModule } from '@angular/material/select';
import { MaintenanceSelectionTypes } from '@app/pages/cmms/configs/cmms-maintenance.enums';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MaintenanceSelectorService } from '@app/pages/cmms/components/au-maintenance-selector/maintenance-selector.service';
import { take } from 'rxjs/operators';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'au-maintenance-selector[selectionType]',
	imports: [MatSelectModule, ReactiveFormsModule, NgxTolgeeModule],
	templateUrl: './au-maintenance-selector.component.html',
	styleUrls: ['./au-maintenance-selector.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuMaintenanceSelectorComponent implements OnInit {
	readonly maintenanceSelectorService = inject(MaintenanceSelectorService);
	selectedDeviation: string;
	configuration: WritableSignal<{
		label: string;
		enumValues: { name: string; description: string }[];
	}> = signal(null);

	@Input() set value(deviation: string) {
		this.formControl.patchValue(deviation || null);
		this.formControlForUI.patchValue(deviation || '0');
	}
	@Input() selectionType: MaintenanceSelectionTypes;
	@Input() newMode = false;

	@Output() controlReady = new EventEmitter<FormControl>();
	@Output() valueChanged = new EventEmitter<any>();

	formControl = new FormControl(null);
	formControlForUI = new FormControl('0');

	ngOnInit(): void {
		this.controlReady.emit(this.formControl);
		this.maintenanceSelectorService
			.getConfiguration(this.selectionType)
			.subscribe(value => {
				this.configuration.set(value);
			});

		if (this.newMode) {
			// Need for new mode, when we have preselected value after return from the other work space like existing or new WO/Assets...
			this.formControl.valueChanges.pipe(take(1)).subscribe(value => {
				this.formControlForUI.patchValue(value || '0');
			});
		}
	}

	selectionchangeHandler(event: any) {
		const value = event.value === '0' ? null : event.value;
		this.formControl.patchValue(value);
		this.valueChanged.emit(value);
	}
}
